export default "__VITE_ASSET__Ctb$YPDH__"